(function () {
  function init(root) {
    var els = (root || document).querySelectorAll('.bb-stat .bb-stat__num:not([data-static])');
    if (!els.length || !('IntersectionObserver' in window)) return;

    function animate(el) {
      var end = parseInt(el.getAttribute('data-target'), 10);
      var dur = 1200, startTime = performance.now();
      function step(now) {
        var p = Math.min((now - startTime) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(end * eased) + (end >= 180 ? '+' : '');
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !entry.target.dataset.done) {
          entry.target.dataset.done = "1";
          animate(entry.target);
        }
      });
    }, { threshold: 0.4 });

    els.forEach(function (el) { io.observe(el); });
  }

  // Initialize after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ init(); });
  } else {
    init();
  }
})();